import WarpElement from "@warp-ds/elements-core";
import "@warp-ds/elements/components/card";
import { css, html } from "lit";
import type { NewCarLatestModelItem } from "../../models/newCarSections.js";
import { trackClickEvent } from "../tracking.js";

class NewCarLatestModels extends WarpElement {
    declare header: string;
    declare items: Array<NewCarLatestModelItem>;

    static properties = {
        header: { type: String },
        items: { type: Array },
    };

    static styles = [
        WarpElement.styles,
        css`
            :host {
                display: block;
            }
            @css-placeholder-dUpe0S;
        `,
    ];

    constructor() {
        super();
        this.header = "";
        this.items = [];
    }

    render() {
        return html`<div class="grid gap-16 max-w-full">
            <h3 class="t3 mb-0">${this.header}</h3>
            <div class="flex gap-16 overflow-x-auto p-12 -m-12">
                ${this.items.map((item) => {
                    const textColor =
                        item.textColor === "light" ? "s-text-inverted-static" : item.textColor === "dark" ? "s-text-static" : "s-text";
                    const headingId = `newcar-latest-model-${item.id}`;

                    return html`<w-card class="max-w-[223] min-w-[223]">
                        <article class="flex flex-col p-16 ${textColor}" style="background-color:${item.backgroundColor}">
                            <a
                                href="${item.href}"
                                aria-owns="${headingId}"
                                class="absolute inset-0 rounded-8 focusable focusable-inset"
                                @click="${() => item.trackingEvent && trackClickEvent(item.trackingEvent)}"
                            ></a>
                            <h4 class="t4" id="${headingId}">${item.name}</h4>
                            <p class="text-detail">${item.displayPrice}</p>
                            <img src="${item.image}" class="w-full" loading="lazy" width="800" height="500" alt="${item.name}" />
                        </article>
                    </w-card>`;
                })}
            </div>
        </div>`;
    }
}

customElements.define("new-car-latest-models", NewCarLatestModels as unknown as CustomElementConstructor);
